export default "__VITE_ASSET__1cc704fe__"